import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { AuthContextProvider, LoaderContext } from "../../AuthContext/AuthContext";
import LoginPopUp from "../../Components/LoginPopup";
import { GetDailyPujaDetailsBySlug } from "../../ApiServices/SlugsApi/GetDailyPujaDetailsBySlugApi";
import { Helmet } from "react-helmet-async";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import "../../Components/PoojaDetails/PujaDetails.css";
import { GetPopularPujaAPI } from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
import { FaqModuleID } from "../../Components/enum";
import batuk from '../../assets/images/new/fav-removebg-preview.png'
import { GetPopularDailyPujaAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import ShareLinkModal from "../../Components/ShareLinkModal";
import { DailyPujaShareMassage } from "../../middlewares/Utils";
import { t } from "i18next";
const DailyBookingDetails = () => {
  const location = useLocation();
  const [loginPopUp, setLoginPopUp] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContextProvider);
  const { setLoader, selectedLanguageID } = useContext(LoaderContext);
  const { slug } = useParams();
  const [showModal, setShowModal] = useState(false);
  const currentUrl = window.location.href;

  const [FAQ, setFaq] = useState([])
  const [popularPujaList, setPopularPujaList] = useState([])
  const [productDetailsData, setProductDetailsData] = useState({
    DP_NAME: null,
    DP_DESC: null,
    DP_IMAGE: null,
    DP_SAMAGRI: null,
    DP_PRICE: null,
    DP_DISC: null,
    DP_SAMAGRI_PRICE: null,
    REG_DATE: null,
    STATUS: null,
    CONVENIENCE_FEE: null,
    ConvinienceFeeTaxPercent: null,
    SamagriPriceTaxPercent: null,
    ConvinienceFeeTaxAmount: null,
    SamagriPriceTaxAmount: null,
    DailyPujaSlug: null,
    DiscountAmount: null,
    MetaTitle: null,
    MetaDescription: null,
    OpenGraphtag: null,
    CanonicalTag: null,
    ExtraMetaTag: null,
    ShortDescription: null,
    KeyFeature: null,
    DailyPujaSlug: null
  });

  useEffect(() => {
    GetProductDetailsBySlugData();
    // GetPopularPujaAPIData()
  }, [location])


  const GetPopularPujaAPIData = async (PUJAId) => {
    setLoader(true);
    try {
      const response = await GetPopularDailyPujaAPI();
      if (response) {
        setLoader(false);
        const pujaList = response.DATA
        const filteredList = pujaList?.filter((val, index) => val?.DP_ID !== PUJAId)
        setPopularPujaList(filteredList);
      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetProductDetailsBySlugData = async () => {
    //  ;
    try {
      const response = await GetDailyPujaDetailsBySlug(slug, selectedLanguageID);

      if (response) {
        const modalData = response.DATA[0];
        if (!modalData) {
          navigate('/*');
          return;
        }
        setProductDetailsData(modalData);
        GetFAQListByServiceData(modalData?.DP_ID)
        GetPopularPujaAPIData(modalData?.DP_ID)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetFAQListByServiceData = async (PujaID) => {
    //  ;
    setLoader(true)
    try {
      const response = await GetFAQListByService(FaqModuleID?.DailyPujaBooking, PujaID);

      if (response) {
        setLoader(false)
        const modalData = response.DATA;

        setFaq(modalData)

      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBookPuja = () => {
    if (isAuthenticated) {
      navigate("/services/daily-puja/add-service", { state: { puja: productDetailsData } });
    } else {
      setLoginPopUp(true);
    }
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  const getDiscountAmount = (price, percentage) => {
    return Math.round((price * percentage) / 100);
  };

  const FaqObj = [
    {
      question: "What services does Myomnamo offer?",
      answer:
        "Myomnamo offers a range of spiritual services, including Puja and Darshan bookings. You can book experienced Pandits for rituals or arrange daily pujas. Our E-Store provides access to religious goods, and Puja samgari, puja kits. Additionally, Myom namo offers horoscope services.",
      color: "#ffa415",
    },
    {
      question: "Can I schedule a temple visit through My OmNamo?",
      answer:
        "Yes, Myomnamo allows you to book temple visits online for your convenience. You can easily select your preferred temple, date, and time through our app. My Om Namo specializes in offering customized puja packages and online Darshans.",
      color: "#fc5528",
    },
    {
      question: "Can I book personalized consultations with spiritual mentors?",
      answer:
        "Yes, Myomnamo provides a platform to book personalized consultations with experienced spiritual mentors. You can connect with mentors who can offer guidance and support on your spiritual journey. These sessions can provide personalized advice and practices tailored to your specific needs",
      color: "#8139e7",
    },
    // {
    //   question: "Why is it important How Volunteer?",
    //   answer:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": productDetailsData?.MetaTitle,
    "description": productDetailsData?.MetaDescription,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": productDetailsData?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": productDetailsData?.CanonicalTag
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": productDetailsData?.MetaTitle,
    "description": productDetailsData?.MetaDescription,
    "url": productDetailsData?.CanonicalTag,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "List",
        "item": "https://www.myomnamo.com/services/daily-booking"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": productDetailsData?.MetaTitle,
        "item": productDetailsData?.CanonicalTag
      }
    ]
  };

  return (
    <div className="PujaDetails">
      <Helmet>
        <title>{productDetailsData?.MetaTitle}</title>
        <meta name="description" content={productDetailsData?.MetaDescription} />
        <link rel="canonical" href={productDetailsData?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={productDetailsData?.MetaTitle} />
        <meta property="og:description" content={productDetailsData?.MetaDescription} />
        <meta property="og:image" content="" />
        <meta property="og:url" content={`https://www.myomnamo.com/services/book-puja/${productDetailsData?.DailyPujaSlug}`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={productDetailsData?.MetaTitle} />
        <meta name="twitter:description" content={productDetailsData?.MetaDescription} />
        <meta name="twitter:image" content="" />
        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>

      </Helmet>
      <div
        className="PujaDetailsContainer"

      >
        <div className="puja-summary-section"  >
          <div className="left-puja-details">
            <img
              src={productDetailsData?.DP_IMAGE}
              alt="Puja-Img"
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.src = placeholderImg; // Set fallback image
              }}
              className="img-fluid rounded" // Bootstrap classes for responsiveness and rounded corners
              style={{ maxWidth: "80%", height: "auto" }}
            />

          </div>
          {/* Right - Description & Features */}
          <div className="right description-container">
            <div className="puja-header">
              <div className="d-flex justify-content-end align-items-center gap-4"
                style={{ width: "100%" }}>
                <button
                  className="pujacustom-btn Normal-app-btn d-none d-lg-block d-md-block"
                  onClick={handleBookPuja}
                >
                  {t("Proceed to Book")}
                </button>

              </div>
              <h1>{productDetailsData?.DP_NAME}</h1>
            </div>

            <div className="d-flex d-lg-none d-md-none mb-1 justify-content-center">
              <button

                className="btn btn-block Normal-app-btn w-50"
                onClick={handleBookPuja}
              >
                {t("Proceed to Book")}
              </button>
            </div>
            {/* Pricing Section */}
            <div className="price-tag position-relative d-inline-block p-2 d-flex  align-items-center">

              <div className="text-dark px-3 py-1 rounded" style={{ background: "#efb423", marginRight: "10px" }}>
                <strong>
                  ₹{" "}
                  {Math.round(Number(productDetailsData.DP_PRICE) - Number(productDetailsData.DiscountAmount))}/ Day
                </strong>

                {/* <strong>
                  ₹{" "}
                  {formatToIndianCurrency(
                    product.PUJA_PRICE - product.DiscountAmount
                  )}
                </strong> */}
              </div>
              {productDetailsData?.DiscountAmount !== null &&
                productDetailsData?.DiscountAmount !== undefined &&
                productDetailsData?.DiscountAmount !== 0 ? (
                <>
                  <span className="original-price">
                    ₹ {productDetailsData?.DP_PRICE}
                  </span>
                  <span className="discount-text">
                    ({Math.round(Number(productDetailsData?.DP_DISC))}% {t("OFF")})
                  </span>
                </>
              ) : (
                ""
              )}
              <button
                className=" custom-share-btn"
                onClick={() => setShowModal(true)}
                title="Share"
              >
                <i className="fa-solid fa-up-right-from-square mx-1"></i>
                {t("Share")}
              </button>
            </div>


            {/* Short Description */}
            <div className="description">
              <div
                dangerouslySetInnerHTML={{ __html: productDetailsData?.ShortDescription }}
              />
              {productDetailsData?.DP_SAMAGRI !== null && productDetailsData?.DP_SAMAGRI !== undefined ? (
                <>
                  <h5>{t("Samagri")}</h5>
                  <div dangerouslySetInnerHTML={createMarkup(productDetailsData?.DP_SAMAGRI)} />
                </>
              ) : ''}

            </div>

            {/* Samagri / Features */}
            {productDetailsData?.KeyFeature !== null && productDetailsData?.KeyFeature !== undefined ? (
              <div className="samagri">
                <h5>{t("Key Features")}</h5>
                <div
                  dangerouslySetInnerHTML={{ __html: productDetailsData?.KeyFeature }}
                />
              </div>
            ) : ''}

          </div>
        </div>
        {/* Description Section */}
        {productDetailsData?.DP_DESC !== null && productDetailsData?.DP_DESC !== undefined ? (
          <div className="detailed-description">
            <h5>{t("Description")}</h5>
            <div
              dangerouslySetInnerHTML={{ __html: productDetailsData?.DP_DESC }}
            />
          </div>
        ) : ''}


        {/* FAQ Section */}
        {FAQ?.length > 0 && (
          <div className="faq-section">
            <section className="faq-one faq-one--page">
              <div
                className="container"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="section-title text-center">

                  <h6
                    className="sec-title__tagline bw-split-in-right"
                    style={{
                      perspective: "400px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                    <img className=" tagline-img" src={batuk} alt="" /> {t("FAQs")}
                    {/* <span className="sec-title__tagline__border"></span> FAQ */}
                  </h6>
                  <h3
                    className="sec-title__title bw-split-in-left"
                    style={{ perspective: "400px", textAlign: "center" }}
                  >
                    {t("Frequently Asked Questions.")}
                  </h3>
                </div>
                <div className="row">
                  <div className="col-xl-2"></div>
                  <div className="col-xl-8">
                    <div className="faq-one__accordion careox-accordion">
                      {FAQ?.map((faq, index) => (
                        <div
                          key={index}
                          className={`accrodion ${activeIndex === index ? "active" : ""
                            }`}
                          style={{ "--accent-color": faq.color }}
                        >
                          <div
                            className="accrodion-title"
                            onClick={() => toggleFAQ(index)}
                          >
                            <h4>
                              <span
                                className="accrodion-title__number"
                                style={{ marginRight: "10px", fontWeight: "500" }}
                              ></span>
                              {faq.QUESTION}
                              <span className="accrodion-title__icon"></span>
                            </h4>
                          </div>
                          <div
                            className="accrodion-content"
                            style={{
                              maxHeight: activeIndex === index ? "200px" : "0",
                              overflow: "hidden",
                              transition: "max-height 0.5s ease-in-out",
                            }}
                          >
                            <div className="inner">
                              <p>{faq.ANSWER}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-xl-2"></div>
                </div>
              </div>
            </section>
          </div>
        )}


        {/* Popular pujas */}
        {popularPujaList?.slice(0, 4)?.length > 0 && (
          <>
            <div
              className="section-title text-center"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                <img className=" tagline-img" src={batuk} alt="" />  {t("Popular Pujas")}
                {/* <span className="sec-title__tagline__border"></span> FAQ */}
              </h6>



              <h6
                className=" bw-split-in-right"
                style={{ width: "50vw", marginTop: "20px" }}
              >
                {t("Explore our most booked pujas! Find peace and prosperity with these powerful ceremonies chosen by devotees like you. Book now!")}
              </h6>
            </div>
            <div
              className="col-12"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "25px",
              }}
            >


              {popularPujaList?.slice(0, 4).map((item, index) => (
                <Link
                  to={`/services/book-puja/${item?.DP_NAME.split(" ")
                    .join("-")
                    .toLowerCase()}`}
                  state={{ product: item }}
                >
                  <div
                    key={index}
                    className="col-lg-3 col-md-6 col-sm-6 product-item-one"
                    style={{
                      marginBottom: "15px",
                      width: "12em",
                      height: "340px",
                    }}
                  >
                    <div
                      className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                      style={{ cursor: "pointer" }}
                    >
                      <div className="product-image text-center position-relative">
                        <img
                          src={item?.DP_IMAGE || placeholderImg}
                          className="img-fluid rounded w-100"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = placeholderImg;
                          }}
                          style={{
                            objectFit: "contain",
                            height: "180px",
                          }}
                        />
                      </div>
                      <div
                        className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                        style={{ margin: "0" }}
                      >
                        <h6
                          style={{
                            fontSize: "18px",
                            color: "#8f3246",
                            fontWeight: "600",
                          }}
                        >
                          {item.DP_NAME}
                        </h6>
                        <div className="prod-details d-flex align-items-center flex-column">
                          <span
                            style={{
                              fontSize: "16px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            ₹ {item.DP_PRICE}
                          </span>
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              color: "#a52444",
                              fontSize: "15px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                            }}
                          >
                            {t("View Details")}{" "}
                            <i className="icon-right-arrow"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </Link>
              ))}
            </div>
          </>
        )}

      </div>
      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}

      <ShareLinkModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        shareUrl={currentUrl}
        message={DailyPujaShareMassage} // Optional
        title="Spread the word" // Optional
      />
    </div>
  );
};

export default DailyBookingDetails;
